import { createSlice } from "@reduxjs/toolkit";

export const toastSlice = createSlice({
  name: "toast",
  initialState: {
    show: false,
    description: "",
    status: "",
    buttonLabel: "view",
    closeIcon: false,
  },
  reducers: {
    showToast: (state, action) => {
      state.show = action.payload?.show;
      state.description = action.payload?.description;
      state.status = action.payload?.status || "success";
      state.buttonLabel = action.payload?.buttonLabel;
      state.closeIcon = action.payload?.closeIcon || false;
    },
  },
});

export const getShowToast = (state) => state.toast;
export const { showToast } = toastSlice.actions;
export default toastSlice.reducer;
